module.exports = __webpack_public_path__ + "img/kf.9463464a.png";